// The position panel of Finance › Receivables › Current Receivables (ReceivablesPositionPanels), reused through its mechanism (useDismissible:
// collapse in place, "Got it" hides it and drops a chip next to the Guide, both remembered per id) and its look (1px line, radius 8, #fbfcfb,
// uppercase 11px title, slate Collapse / Got it buttons). Used by the Invoices register (To invoice, Issued) and the order's Invoices tab.
import React from 'react';
import { useDismissible } from '../../../components/useDismissible';
import { IcoLn } from '../../../shell/ActionIcons';

const btn = { border: '1px solid var(--ctl-border)', fontSize: 11.5, fontWeight: 600, padding: '4px 10px', borderRadius: 7, cursor: 'pointer', background: 'rgba(100,116,139,.14)', color: 'var(--muted)' };

export default function PositionPanel({ id, title, chip, icon, t, testid, titleExtra, children }) {
  const d = useDismissible(id, icon ? <><IcoLn name={icon} /> {chip}</> : chip);
  return <>
    {!d.dismissed && (
      <div data-testid={testid} style={{ marginBottom: 14, border: '1px solid var(--line)', borderRadius: 8, padding: '10px 14px', background: 'var(--surface)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: d.collapsed ? 0 : 9, flexWrap: 'wrap' }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.04em' }}>{title}</div>
          {titleExtra}
          <span style={{ flex: 1 }} />
          <button type="button" onClick={d.toggleCollapse} className="gotit pos" style={btn}>{d.collapsed ? t('posExpand') : t('posCollapse')}</button>
          <button type="button" onClick={d.dismiss} className="gotit pos" style={btn}>{t('posGotIt')}</button>
        </div>
        {!d.collapsed && children}
      </div>
    )}
    {d.chip}
  </>;
}
